import { t } from "i18next";
import map from "./map";

window.expressMap = function create(apiKey, element, baseLatitude, baseLongitude, baseZoom, saveLink) {
    const packetUrl = '/admin-zas/zasilky?#&param=hled%253D'; // Hardcoded because there is no presenter :(

    map.init(element, `https://api.mapy.cz/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=${apiKey}`);

    // Layer with Marks of packets
    const marksGroup = map.addLayerGroup();

    // Layer with list of selected packets for parcel creation/modify
    const selectedPacketsLayer = map.addLayer('topleft');

    // Layer with line between selected packets
    const trackLine = map.addPolyline('red');

    // Layer with list of packets close to each other
    const proximityPacketsLayer = map.addLayer('topleft');
    
    // All packets
    let packets = [];
    // Selected packets for parcel creation/edit
    let selectedPackets = [];
    // Packets close together
    let proximityPackets = [];
    // Packet barcodes from edited parcel
    let editPackets = [];
    // Edited parcel Id
    let parcelId = null;
    // hide packet already in parcel
    let isInParcel = true;

    map.setView(baseLatitude, baseLongitude, baseZoom);

    function setPackets(_packets, _editPackets = [], _parcelId)
    {
        packets = _packets;
        editPackets = _editPackets;
        parcelId = _parcelId;
        selectedPackets = [];
        proximityPackets = [];

        packets.forEach(function(packet) {
            // fake GPS if missing dont ask me why
            packet.fakeGps = false;
            if (packet.latitude === 0) {
                packet.latitude = baseLatitude + 0.07 - packet.barcode.substr(7) / 5000;
                packet.longitude = baseLongitude - 0.15 + packet.barcode.substr(7) / 2000;
                packet.fakeGps = true;
            }
        });

        editPackets.forEach(function(barcode) {
            packets.forEach((packet) => {
                if(parseInt(packet.barcode) === barcode) {
                    selectedPackets.push(packet);
                }
            });
        });

        reDrawPackets();
    }

    function setPopUpButton(buttonId, valueId)
    {
        const barcodeLastCharsButton = document.getElementById(buttonId);
        barcodeLastCharsButton.addEventListener('click', () => {
            popupPacket(input.value);
        });

        const input = document.getElementById(valueId);
        input.addEventListener("keypress", function(event) {
            if (event.key === "Enter") {
              barcodeLastCharsButton.click();
            }
        });
    }

    function setCheckBox(boxId)
    {
        const notInParcelsCheckBox = document.getElementById(boxId);
        notInParcelsCheckBox.addEventListener('change', (event) => {
            isInParcel = !event.currentTarget.checked;
            reDrawPackets();
        });
    }

    function proximityMove(packet, proximity) {
        let lonRectBegin = removeGpsPrecision(packet.longitude);
        let latRectBegin = removeGpsPrecision(packet.latitude);

        const key = latRectBegin + "-" + lonRectBegin;

        if(!proximity[key]) {
            proximity[key] = [];
        }
        proximity[key].push(packet);

        if (proximity[key].length > 1) {
            return 0.001 * (proximity[key].length - 1);
        }
        return 0;
    };

    function reDrawPackets()
    {
        marksGroup.clearLayers();
        proximityPackets = [];

        let proximity = {};

        packets.forEach((packet) => {
            if (isInParcel === false && parseInt(packet.in_todays_parcel) === 1) {
                return;
            }

            // This will make packet on wrong position probably just to not overlap close packets
            const move = proximityMove(packet, proximity);
            packet._latitude = packet.latitude;
            packet._longitude = packet.longitude + move;

            const mark = map.addMarkerToLayer(marksGroup, packet._latitude, packet._longitude, htmlPacketMark(packet), htmlPopUp(packet));
            mark.barcode = packet.barcode;
            mark.packet = packet;
            // Mark right click event
            mark.on('contextmenu', function(e) {
                const index = getIndexOfObjectInList(e.target.packet, selectedPackets);
                if (index === false) {
                    selectedPackets.push(e.target.packet);
                } else {
                    delete selectedPackets[index];
                    selectedPackets = selectedPackets.filter(Boolean);
                    updateSelectedPacketIndex(e.target.packet.barcode, null, e.target.packet.color);
                }
                reDrawSelectedPackets(parcelId);
            });
        });

        reDrawSelectedPackets(parcelId);

        Object.keys(proximity).forEach(function(key) {
            if(proximity[key].length > 1) {
                proximity[key].forEach((p) => {
                    proximityPackets.push(p);
                })
            }
        });

        reDrawProximityPackets(proximityPackets);
    }

    function reDrawProximityPackets(proximityPackets)
    {
        proximityPacketsLayer._div.innerHTML = htmlProximityPackets(proximityPackets);
        // Add on click popup events
        const lis = document.querySelectorAll('#proximity-list li');
        lis.forEach((li) => {
            li.addEventListener("click", () => {
                // delay because of map manipulation will remove popup :(
                setTimeout(function() {
                    popupPacket(li.dataset.barcode);
                },100);
            });
        })
    }

    function reDrawSelectedPackets(parcelId)
    {
        let points = [];
        let i = 1;
        selectedPackets.forEach((packet) => {
            points.push([
                packet._latitude,
                packet._longitude
            ]);
            updateSelectedPacketIndex(packet.barcode, i++, packet.color);
        });
        trackLine.setLatLngs(points);

        selectedPacketsLayer._div.innerHTML = htmlSelectedPackets(selectedPackets, parcelId);
        // Drag and drop functionality
        $("#selected-list").sortable({
            // Prevent map panning when dragging item
            start: function() {
                map.leafletMap.dragging.disable();
            },
            stop: function() {
                map.leafletMap.dragging.enable();
            },
            update: function() {
                let htmlItemsList = this.getElementsByTagName('li');
                let sortedBarcodes = [];
                for (i = 0; i < htmlItemsList.length; i++) {
                    sortedBarcodes.push(htmlItemsList[i].dataset.barcode);
                }
                selectedPackets.sort((a, b) => {
                    const aIndex = sortedBarcodes.indexOf(a.barcode);
                    const bIndex = sortedBarcodes.indexOf(b.barcode);
                    if (aIndex < bIndex) {
                        return -1;
                    }
                    if (aIndex > bIndex) {
                        return 1;
                    }
                    return 0;
                });
                reDrawSelectedPackets(parcelId);
            }
        });
    }

    function popupPacket(barcodeEndsWith) {
        marksGroup.eachLayer((mark) => {
            mark.closePopup();
            if (barcodeEndsWith && mark.barcode.slice(-barcodeEndsWith.length) === barcodeEndsWith) {
                mark.openPopup();
            }
        });
    }

    function htmlProximityPackets(proximityPackets)
    {
        if (proximityPackets.length === 0) {
            return '';
        }
        let list = '';
        proximityPackets.forEach((packet) => {
            list += `<li class="list-group-item mx-0 p-2" data-barcode="${packet.barcode}">`
            + `<a href="#/">Z ${packet.barcode.substr(0, packet.barcode.length - 3)} <b style="font-size:17px">${packet.barcode.slice(-3)}</b></a> ${packet.name}`
            + `</li>`;
        });
        return `<div class="card p-0" style="max-width: 13rem">`
        + `<div class="card-header text-danger h5"><b>${t('expressMap.packetsClose')}</b></div>`
        + `<ul class="list-group list-group-flush text-nowrap text-truncate" id="proximity-list">`
        + list
        + `</ul>`
        + `</div>`;
    }

    function htmlSaveParcelForm(parcelId, packets)
    {
        return `<form method="post" target="_blank" action="${saveLink}">`
        + `<input type="hidden" name="packets" value="${packets.toString()}">`
        + `<input type="hidden" name="modifyParcelId" value="${(parcelId != null ? parcelId : '')}">`
        + `<div class="btn-group btn-group-sm" role="group">`
        + `<input onClick="setTimeout(()=>(window.location=window.location.href.split('?')[0]), 1000)" class="btn btn-sm btn-primary" type="submit" value="${(parcelId != null ? t('expressMap.saveChanges') : t('expressMap.createParcel'))}">`
        + (parcelId != null ? `<button onClick="window.location=window.location.href.split('?')[0]" class="btn btn-sm btn-outline-primary" type="button" >${t('expressMap.back')}</button>` : ``)
        + `</div>`
        + `</form>`;
    }

    function htmlSelectedPackets(selectedPackets, parcelId)
    {
        if (selectedPackets.length === 0) {
            return '';
        }

        let list = '';
        let barcodes = [];
        selectedPackets.forEach((packet) => {
            barcodes.push(packet.barcode);
            list += `<li class="list-group-item mx-0 p-2" data-barcode="${packet.barcode}">`
            + `<a href="${packetUrl}Z${packet.barcode}">Z ${packet.barcode.substr(0, packet.barcode.length - 3)} <b style="font-size:17px">${packet.barcode.slice(-3)}</b></a> ${packet.name}`
            + `</li>`;
        });
        let form = htmlSaveParcelForm(parcelId, barcodes);
        return `<div class="card p-0" style="max-width: 13rem">`
        + `<div class="card-header h5"><b>${t('expressMap.newParcel')}</b></div>`
        + `<ul class="list-group list-group-numbered list-group-flush text-nowrap text-truncate" style="cursor: all-scroll;" id="selected-list">`
        + list
        + `</ul>`
        + `<div class="card-body p-1">`
        + form
        + `</div>`
        + `<div class="card-footer text-muted">${t('expressMap.dragName')}.</div>`
        + `</div>`;
    }

    function htmlPopUp(packet)
    {
        return `<div class="card">`
        + `<div class="card-header">`
        + `<a target="_blank" href="${packetUrl}Z${packet.barcode}">`
        + `Z ${packet.barcode.substr(0, packet.barcode.length - 3)}<b style="font-size:17px">${packet.barcode.slice(-3)}</b>`
        + `</a>`
        + `</div>`
        + `<div class="card-body">`
        + `${packet.name}<br>`
        + `${packet.address}<br>`
        + `${packet.phone}<br>`
        + `${t('expressMap.cod')}: ${(packet.cod ? packet.cod : t('expressMap.no'))}`
        + `</div>`
        + `</div>`;
    }

    function htmlPacketMark(packet)
    {
        let iconUrl = packet.fakeGps === false ? (packet.is_today === true ? (true ? "/zas-is/images/map-marker/blue.png" : "/zas-is/images/map-marker/yellow.png") : "/zas-is/images/map-marker/aqua.png") : "/zas-is/images/map-marker/red.png";
        const color = packet.is_today === false ? 'black' : 'white';
        const content = (packet.fakeGps === false) ? `${packet.eshop.substr(0,5)}<br>${packet.barcode.substr(-3)}<br>${packet.recv}` : `<div class="px-2" style="width:40px;overflow-wrap:break-word;">${t('expressMap.notFound')}</div>${packet.recv}`;

        return `<div id="mark_${packet.barcode}" style="width:40px;height:54px;color:${color};background:#${packet.color};">`
        + `<img style="position:absolute;padding: 2px 3px;" src="${iconUrl}">`
        + `<table style="font-size:9px;line-height:10px;position:absolute;width:44px;">`
        + `<tbody>`
        + `<tr>`
        + `<td style="text-align:center;padding-top:5px" align="center" valign="middle">`
        + content
        + `</td>`
        + `</tr>`
        + `</tbody>`
        + `</table>`
        + (packet.in_todays_parcel != 1 ? `<div style="position:absolute;left:0;top:50px;height:4px;width:40px;background:black;"></div>` : ``)
        + `<div hidden class="mark-num" style="font-size: 9px; font-weight: bold; padding: 0 3px; position: absolute; left: 0; top: 40px; background: red; color: white; ">#</div>`
        + `</div>`;
    }

    function updateSelectedPacketIndex(barcode, number, backgroundColor)
    {
        const markDiv = document.getElementById('mark_' + barcode);
        if (markDiv === null) {
            return;
        }
        const num = markDiv.querySelector('.mark-num');
        if (number) {
            num.innerHTML = number;
            num.removeAttribute('hidden');
            markDiv.style.background = 'white';
        } else {
            num.setAttribute('hidden', '');
            markDiv.style.background = `#${backgroundColor}`;
        }
    }

    function removeGpsPrecision(value) {
        return Math.floor(value * map.gpsPrecision ) / (map.gpsPrecision);
    }

    function getIndexOfObjectInList(obj, list) {
        let i;
        for (i = 0; i < list.length; i++) {
            if (list[i] === obj) {
                return i;
            }
        }
        return false;
    }

    return {
        setPackets,
        setPopUpButton,
        setCheckBox
    }
}